import {
  PageHeaderTopRow as PageHeaderTopRowBase,
  type PageHeaderTopRowProps as PageHeaderTopRowPropsBase,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { RootPaths } from "@src/appV2/App/paths";
import { useHistory, useLocation } from "react-router-dom";

import { ButtonInternalLink } from "./ButtonInternalLink";

export interface PageHeaderTopRowProps
  extends Omit<PageHeaderTopRowPropsBase, "navigateBack" | "LinkComponent"> {
  fallbackGoBackPath?: string;
}

export function PageHeaderTopRow(props: PageHeaderTopRowProps) {
  const { fallbackGoBackPath = RootPaths.HOME } = props;

  const history = useHistory();
  const location = useLocation();

  return (
    <PageHeaderTopRowBase
      {...props}
      navigateBack={() => {
        // no key means we can't go back
        if (isDefined(location.key)) {
          history.goBack();
        } else {
          history.push(fallbackGoBackPath);
        }
      }}
      LinkComponent={ButtonInternalLink}
    />
  );
}
